import { useHistory } from "react-router-dom";
import * as Routes from "routes";

type History = ReturnType<typeof useHistory>;

// The explorer reads this on mount to preselect the dataset's layer.
export const viewDatasetInExplorer = (
  datasetProductCode: string,
  history: History,
) => {
  sessionStorage.setItem("catalogueToExplorer", datasetProductCode);
  history.push(Routes.dataExplorer);
};
